import { render, staticRenderFns } from "./WalletCard.vue?vue&type=template&id=7c738267&scoped=true&"
import script from "./WalletCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./WalletCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./WalletCard.vue?vue&type=style&index=0&id=7c738267&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c738267",
  null
  
)

export default component.exports